import { apiSlice } from '../../api';
import {
  GetNotificationResponse,
  GetNotificationUnreadCountResponse,
  GetNotificationsArg,
} from './type';

const notificationsEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getNotifications: build.query<GetNotificationResponse, GetNotificationsArg>({
      query: (data) => ({
        url: `admin/v1/notifications?limit=${data.limit}&offset=${data.offset}`,
        method: 'GET',
      }),
    }),
    getNotificationsUnreadCount: build.query<GetNotificationUnreadCountResponse, void>({
      query: () => ({
        url: 'admin/v1/notifications/unread',
        method: 'GET',
      }),
    }),
    deleteAllNotifications: build.query<void, void>({
      query: () => ({
        url: 'admin/v1/notifications',
        method: 'DELETE',
      }),
    }),
    readAllNotification: build.query<void, void>({
      query: () => ({
        url: 'admin/v1/notifications',
        method: 'PUT',
      }),
    }),
    readNotificationById: build.query<void, string>({
      query: (data) => ({
        url: `admin/v1/notifications/${data}`,
        method: 'PUT',
      }),
    }),
    deleteNotificationById: build.query<void, string>({
      query: (data) => ({
        url: `admin/v1/notifications/${data}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useGetNotificationsUnreadCountQuery,
  useLazyGetNotificationsUnreadCountQuery,
  useLazyDeleteAllNotificationsQuery,
  useLazyDeleteNotificationByIdQuery,
  useLazyReadAllNotificationQuery,
  useLazyReadNotificationByIdQuery,
} = notificationsEndpoints;
